<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Consultar Pagos
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Cuenta corriente</span>
      <span> /</span>
      <span class="grey-text">Pagos</span>
      <span> /</span>
      <span>Consultar Pagos </span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate>
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fecha_desde"></mdb-date-picker>
            <!-- <div *ngIf="
                formHeader.get('fecha_desde').invalid &&
                (formHeader.get('fecha_desde').dirty ||
                formHeader.get('fecha_desde').touched)
              ">
              <mdb-error *ngIf="formHeader.get('fecha_desde').hasError('required')">Ingrese fecha
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col" style="max-width: 200px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fechahasta" [placeholder]="'Hasta'" required
              formControlName="fecha_hasta"></mdb-date-picker>
            <!-- <div *ngIf="
                formHeader.get('fecha_hasta').invalid &&
                (formHeader.get('fecha_hasta').dirty ||
                formHeader.get('fecha_hasta').touched)
              ">
              <mdb-error *ngIf="formHeader.get('fecha_hasta').hasError('required')">Ingrese fecha
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="rutcliente" class="form-control" placeholder="9.999.999-9" required
              #rutcliente formControlName="rutCliente" formatRut />
            <label for="rutcliente">RUT cliente</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarCliente()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ clienteSeleccionado?.razon_social }}
          </h6>
        </div>
        <div class="col">
          <div class="md-form">
            <mdb-checkbox formControlName="es_liquidacion">Por Liquid. recor.</mdb-checkbox>
            <mdb-checkbox formControlName="pagado">Por Cobranza</mdb-checkbox>
          </div>
        </div>
        <div class="col" style="max-width: 100px;">
          <div class="md-form">
            <input value="" type="text" id="nroPago" class="form-control" placeholder="9999" required #nroPago
              formControlName="codigo" onlyNumbers />
            <label for="nroPago">Nro. Folio</label>
          </div>
        </div>
        <div *ngIf="formHeader.get('pagado').value === false" class="col d-flex" style="max-width: 100px;">
          <div class="md-form">
            <input value="" type="text" id="recorrido_codigo" class="form-control" placeholder="000"
              formControlName="recorrido_codigo" />
            <label for="recorrido_codigo">nro. recorrido</label>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 120px;">
          <div class="md-form">
            <input value="" type="text" id="monto" class="form-control" placeholder="$ 000.000" #monto
              formControlName="monto" />
            <label for="monto">Monto abonado</label>
          </div>
        </div>
      </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6;">
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>

      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>

  <div class="card mb-2 wow detalle-cliente" *ngIf="listaMovimientos">
    <div class="card-body justify-content-between">
      <!-- <div class="row filtros-body">
      <div class="col">
        <h5>Listado de pagos</h5>
      </div>
    </div> -->
      <div class="table-responsive">
        <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
          <thead class="grey lighten-2">
            <tr>
              <th scope="col" style="width: 8rem; max-width: 8rem;">F. Pago</th>
              <th scope="col" style="width: 8rem; max-width: 8rem;">F. Emision</th>
              <th scope="col">Folio</th>
              <th scope="col">RUT</th>
              <th scope="col">Cliente</th>
              <th scope="col">Abonado</th>
              <th scope="col">Recorrido</th>
              <th scope="col">Origen</th>
              <th scope="col">Nombre Recaudador</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading">
              <td colspan="100%" style="text-align: center">
                <mdb-spinner spinnerColor="blue"></mdb-spinner>
              </td>
            </tr>
            <tr *ngIf="!loading && listaMovimientos?.length === 0">
              <td colspan="100%" style="text-align: center">
                No se encontró información
              </td>
            </tr>
            <tr *ngFor="let mov of listaMovimientos; let i = index;">
              <td>{{mov.fecha_pago | fecha}}</td>
              <td>{{mov.fecha_emision | fecha}}</td>
              <td>{{mov.folio}}</td>
              <td>{{mov.rutFormato | rut}}</td>
              <td>{{mov.cliente_proveedor_nombre}}</td>
              <td>$ {{mov.monto_abonado | numerico}}</td>
              <td>{{mov.recorrido_codigo}}</td>
              <td>{{mov.origen}}</td>
              <td>{{mov.nombre_recaudador}}</td>
              <td>
                <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                  (click)="loadAndShowPago(mov)" mdbTooltip="Ver" placement="right">
                  <mdb-icon fas icon="eye"></mdb-icon>
                </button>
              </td>
            </tr>
          </tbody>
          <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
            *ngIf="listaMovimientos?.length > 0"></app-pagination>
        </table>
      </div>
    </div>
  </div>

  <div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
    <div class="card-body d-sm-flex p-1 justify-content-end">

      <div class="md-form" style="min-width: 200px;">
        <mdb-select formControlName="orden_envio" [options]="optionsOrderConsulta" [filterEnabled]="true"
          [highlightFirst]="false" placeholder="Seleccionar orden">
        </mdb-select>
        <label>Orden de consulta</label>
      </div>

      <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="downloadExcelPdf('XLS')" [disabled]="loadingExcel">
        <span class="spinner-border spinner-border-sm" *ngIf="loadingExcel" role="status" aria-hidden="true"></span>
        Excel
      </button>

      <button mdbBtn type="button" color="primary" mdbWavesEffect class="btn" (click)="downloadExcelPdf('PDF')">
        PDF
      </button>
    </div>
  </div>
</form>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente [multiple]="false" (onSelectSingle)="onClienteSeleccionado($event)"
  queryType="ONLY_RUT_BLO_DESB" showInfoClienteInactivoBloqueado="true" (onNotFound)="onClienteNoEncontrado()">
</app-modal-seleccionar-cliente>

<!-- MODAL verPago-->
<app-consultar-pagos-modal-view-details></app-consultar-pagos-modal-view-details>
